import { compact, flow, isEqual, isNull, map, reject, sum } from 'lodash/fp';
import { createSelector } from 'reselect';
import { Hidden, Price } from '@ahmdigital/ui';
import { useSelector } from 'react-redux';
import React from 'react';

import getFutureDate from '../../../../../../utils/get-future-date';
import PriceService, { Price as PriceData } from '../../../../../../models/price';
import selectBuildYourCover from '../../../../../../selectors/select-build-your-cover';
import selectCustomer from '../../../../../../selectors/select-customer';
import selectEffectiveDateOverride from '../../../../../../selectors/select-effective-date-override';
import selectPrices from '../../../../../../selectors/select-prices';

const selectStateForComponent = createSelector(
  [selectCustomer, selectEffectiveDateOverride, selectPrices, selectBuildYourCover],
  (customer, effectiveDateOverride, prices, { selectedProducts }) => {
    const selectedProductIds = reject(isNull, selectedProducts) as string[];
    const date = getFutureDate(effectiveDateOverride);
    const allPrices = compact(PriceService.getPrices(prices, selectedProductIds, customer, { date }));

    return {
      frequency: customer.frequency,
      isLoading: allPrices.length !== selectedProductIds.length,
      selectedTotalProductPrice:
        allPrices.length > 0
          ? flow(
              // @ts-expect-error [🤖 PLEASE FIX 🤖]: Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
              map((priceData: PriceData) => parseFloat(priceData.amount?.[customer.frequency])),
              sum,
            )(allPrices)
          : null,
    };
  },
);

const ProductPriceTotal = () => {
  const { frequency, isLoading, selectedTotalProductPrice } = useSelector(selectStateForComponent, isEqual);

  if (selectedTotalProductPrice) {
    const totalPriceForPriceComponent = PriceService.getPriceAsObject(selectedTotalProductPrice);

    return (
      <>
        <Hidden xs sm md>
          <Price frequency={frequency} price={totalPriceForPriceComponent} showAsterisk showFrom isFrequencyInline />
        </Hidden>
        <Hidden lg df>
          <Price frequency={frequency} price={totalPriceForPriceComponent} showAsterisk showFrom />
        </Hidden>
      </>
    );
  }

  return (
    <Price frequency={frequency} price={isLoading ? null : { cents: '--', dollars: '--' }} showAsterisk showFrom />
  );
};

export default ProductPriceTotal;
